const Helper = {
  g: ({ yrs, i }) => {
    var p = 10;
    var x = p * Math.pow(1 + i, yrs);
    return x.toFixed(2);
  },
  StackdData: ({ bm_annualized_return, fund_annualized_return }) => {
    var StackData = [];

    for (let i = 1; i < 21; i++) {
      StackData.push(
        {
          value: Helper.g({ yrs: i, i: bm_annualized_return }),
          date: i,
          key: "bmReturn",
        },
        {
          value: Helper.g({ yrs: i, i: fund_annualized_return }),
          date: i,
          key: "fundReturn",
        }
      );
    }
    return StackData;
  },
  StackedData2: ({ bm_annualized_return, fund_annualized_return }) => {
    var StackedData2 = [];
    for (let i = 1; i < 21; i++) {
      StackedData2.push({
        Benchmark: Helper.g({ yrs: i, i: bm_annualized_return }) * 1,
        Portfolio: Helper.g({ yrs: i, i: fund_annualized_return }) * 1,
        date: i,
      });
    }
    return StackedData2;
  },

  moneyFormat: ({ number }) => {
    let val =
      Math.abs(Number(number)) >= 1.0e3003
        ? Math.abs((Number(number) / 1.0e3003).toFixed(2)) + "Millinillion"
        : Math.abs(Number(number)) >= 1.0e63
        ? Math.abs((Number(number) / 1.0e63).toFixed(2)) + "Vigintillion"
        : Math.abs(Number(number)) >= 1.0e60
        ? Math.abs((Number(number) / 1.0e60).toFixed(2)) + "Novendecillion"
        : Math.abs(Number(number)) >= 1.0e39
        ? Math.abs((Number(number) / 1.0e39).toFixed(2)) + "Duodecillion"
        : Math.abs(Number(number)) >= 1.0e36
        ? (Math.abs(Number(number)) / 1.0e36).toFixed(2) + "Undecillion"
        : Math.abs(Number(number)) >= 1.0e33
        ? (Math.abs(Number(number)) / 1.0e33).toFixed(2) + "Decillion"
        : Math.abs(Number(number)) >= 1.0e30
        ? (Math.abs(Number(number)) / 1.0e30).toFixed(2) + "Nonillion"
        : Math.abs(Number(number)) >= 1.0e27
        ? (Math.abs(Number(number)) / 1.0e27).toFixed(2) + "Octillion"
        : Math.abs(Number(number)) >= 1.0e24
        ? (Math.abs(Number(number)) / 1.0e24).toFixed(2) + "Y"
        : Math.abs(Number(number)) >= 1.0e21
        ? (Math.abs(Number(number)) / 1.0e21).toFixed(2) + "Z"
        : // quadrillion
        Math.abs(Number(number)) >= 1.0e18
        ? (Math.abs(Number(number)) / 1.0e18).toFixed(2) + "E"
        : // quadrillion
        Math.abs(Number(number)) >= 1.0e15
        ? (Math.abs(Number(number)) / 1.0e15).toFixed(2) + "P"
        : Math.abs(Number(number)) >= 1.0e12
        ? (Math.abs(Number(number)) / 1.0e12).toFixed(2) + "T"
        : Math.abs(Number(number)) >= 1.0e9
        ? (Math.abs(Number(number)) / 1.0e9).toFixed(2) + "B"
        : Math.abs(Number(number)) >= 1.0e6
        ? (Math.abs(Number(number)) / 1.0e6).toFixed(2) + "M"
        : Math.abs(Number(number)) >= 1.0e3
        ? (Math.abs(Number(number)) / 1.0e3).toFixed(2) + "K"
        : Math.abs(Number(number)).toFixed(2);
    return val;
  },
};

export default Helper;



// WEBPACK FOOTER //
// ./src/components/myPortfolios/cards/helper/Helper.js